var map = {
	"./img-features-feature-6-parents_cn.png": "PF9B",
	"./img-features-feature-6-parents_en.png": "hFjE",
	"./img-features-feature-6-parents_ja.png": "6F8P",
	"./img-features-feature-6-parents_ko.png": "maeM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VkTP";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features ^\.\/img\-features\-feature\-6\-parents_.*\.png$
// module id = VkTP
// module chunks = 18